import { Component } from '@angular/core';
import { intToTime } from '../../../helpers/formatNumbers';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-kpi-sessions-summary',
  templateUrl: './kpi-sessions-summary.component.html',
  styleUrl: './kpi-sessions-summary.component.scss',
})
export class KpiSessionsSummaryComponent {
  isLoading = true;

  formatTimeFunction = intToTime;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.sessionsKpisSummary$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('sessionsKpisSummary');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getKpisSummary().subscribe();
  }

  get data() {
    return this.analyticsService.sessionsKpisSummary$.value?.data || [];
  }
}
